import { vestResolver } from "@hookform/resolvers/vest";
import { FC, useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { FormSuite } from "../FormModel/PrestaValidator";
import { UseConfigContext } from "../Context/ConfigContext";
import { Cl_PrestaImport } from "../Model/PrestaData";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { UseTranslationContext } from "../Context/TranslationContext";
import { UseCodeListContext } from "../Context/CodeListContext";
import { ImportPrestaData } from "./PrestaProcessHelper";
import { CheckPrestaAccessEmployer, CheckPrestaEmployee, GetPrestaData, GetPrestaDataCrypted, InitPresta } from "../services/PrestaService";

import Lottie from "lottie-react";
import spinner from "../FormModel/lottie_spinner.json";

import { UseToastContext, toastType } from "../Context/ToastContext";

const PrestaComponent: FC = () => {

  const { isConfigLoaded, getServiceUrl } = UseConfigContext();
  
  const {updateSalarySimData} = UseSalarySimContext();
  const {getKeyFromKeyId, isTranslationLoaded} = UseTranslationContext();
  const {codeListForm, codeListJointCommittee, codeListNSSOPrefix, isLoaded} = UseCodeListContext();

  const [employerName, setEmployerName] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  const [employerValid, setEmployerValid] = useState(0); // 0 : not checked, 1 : checked ok, 2 : checked not ok
  const [employeeValid, setEmployeeValid] = useState(0); // 0 : not checked, 1 : checked ok, 2 : checked not ok

  const [prestaPopupDisplay, setPrestaPopupDisplay] = useState(false);

  const [prestaLoadingInProgress, setPrestaLoadingInProgress] = useState(false);

  const { popToast } = UseToastContext();

  const [prestaImportMessage, setPrestaImportMessage] = useState("");

  const { register, handleSubmit, setValue, trigger, formState: { errors }, control } = useForm({
    resolver: vestResolver(FormSuite),
    mode: 'onChange',
    reValidateMode: 'onChange',
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: false,
    shouldUnregister: false,
    delayError: undefined,
  });

  const formPrestaEmployer = useWatch({ control, name: "employerNum"});
  const formPrestaEmployee = useWatch({ control, name: "employeeNum"});

  useEffect(() => {
    if(isConfigLoaded == true && isLoaded == true && isTranslationLoaded == true)
    {
      const queryParams = new URLSearchParams(window.location.search);
      const employer = queryParams.get('arg1');
      const employee = queryParams.get('arg2');
      
      if(employer && employee)
      {
          handleClickOpen();
          setPrestaLoadingInProgress(true);
          var prestaDataPromise = GetPrestaDataCrypted(getServiceUrl(), employer, employee);
          prestaDataPromise.then(
            Result => 
            {
                setPrestaLoadingInProgress(false);

                if(typeof(Result) == 'string')
                {
                  popToast(toastType.Error, getKeyFromKeyId(Result as string));
                }
                else
                {
                  setEmployerValid(Result.employerAccessOk?1:2);
                  setEmployeeValid(Result.employeeAccessOk?1:2);
      
                  if(Result.employerAccessOk && Result.employeeAccessOk)
                  {
                    if(Result.dataImportOk && Result.prestaData != null)
                    {
                      setValue("employerNum", Result.prestaData.NoEmployeur);
                      setValue("employeeNum", Result.prestaData.NoContrat);
  
                      setEmployeeName(Result.prestaData.Nom + " " + Result.prestaData.Prenom);
                      var prestaDataConverted = ImportPrestaData((Result as Cl_PrestaImport).prestaData, codeListForm, codeListJointCommittee, codeListNSSOPrefix, getKeyFromKeyId, setPrestaImportMessage);
                      
                      if(updateSalarySimData != undefined) // we call all 3 to avoid having to create additional conditions in the updateData function
                      {
                         prestaDataConverted.UserName = Result.prestaData.NoEmployeur + " - " + Result.prestaData.NoContrat + " - " + Result.prestaData.Nom + " " + Result.prestaData.Prenom;
                         updateSalarySimData(prestaDataConverted, 0, false);
                      }
                    }
                    else
                    {
                      var messageError = "PRESTA DATA IMPORT ERROR FOR EMPLOYER : " + formPrestaEmployer + "AND EMPLOYEE " + formPrestaEmployee;
                      setPrestaImportMessage(messageError);
                    }
                  }
                }
  
                return Result;
            })
            .catch(e => 
            { 
                popToast(toastType.Error, "Error presta");
            });
      }
    }
  }, [isConfigLoaded, isLoaded, isTranslationLoaded]);

  const UpdateEmployer = (e: any) => {
    setValue('employeeNum',0);
    setEmployeeName('');
    setEmployeeValid(0);

    setEmployerName('');
    setEmployerValid(0);
  }

  const UpdateEmployee = (data: any) => {
    setEmployeeName('');
    setEmployeeValid(0);
  }

  const TryLoadFromPresta = async () => {

    setPrestaImportMessage("");
    if(formPrestaEmployer == null || isNaN(formPrestaEmployer) || formPrestaEmployer == 0 || formPrestaEmployer == undefined)
    {
      // no employer. abort
      setEmployerValid(2);
      setEmployeeValid(0);
    }
    else
    {
      if(formPrestaEmployee == null || isNaN(formPrestaEmployee) || formPrestaEmployee == 0 || formPrestaEmployee == undefined)
      {
        // no employee : we only check the employer validity
        var checkEmployer = await ServiceCheckPrestaAccessEmployer(formPrestaEmployer);
        setEmployeeName("");
      }
      else // employee + employer ok : we try to load the data from presta
      {
        // no employee : we only check the employer validity ( to display the name )
        var checkEmployer = await ServiceCheckPrestaAccessEmployer(formPrestaEmployer);

        // then we load the data
        setPrestaLoadingInProgress(true);
        var prestaDataPromise = await GetPrestaData(getServiceUrl(), formPrestaEmployer, formPrestaEmployee);
        setPrestaLoadingInProgress(false);
        if(prestaDataPromise != null)
        {
          if(typeof prestaDataPromise == 'string')
          {
            popToast(toastType.Error, getKeyFromKeyId(prestaDataPromise));
          }
          else
          {
            setEmployerValid(prestaDataPromise.employerAccessOk?1:2);
            setEmployeeValid(prestaDataPromise.employeeAccessOk?1:2);

            if(prestaDataPromise.employerAccessOk && prestaDataPromise.employeeAccessOk)
            {
              if(prestaDataPromise.dataImportOk && prestaDataPromise.prestaData != null)
              {
                setEmployeeName(prestaDataPromise.prestaData.Nom + " " + prestaDataPromise.prestaData.Prenom);
                

                var prestaDataConverted = ImportPrestaData((prestaDataPromise as Cl_PrestaImport).prestaData, codeListForm, codeListJointCommittee, codeListNSSOPrefix, getKeyFromKeyId, setPrestaImportMessage);
                
                if(updateSalarySimData != undefined) // we call all 3 to avoid having to create additional conditions in the updateData function
                {
                   prestaDataConverted.UserName = prestaDataPromise.prestaData.NoEmployeur + " - " + prestaDataPromise.prestaData.NoContrat + " - " + prestaDataPromise.prestaData.Nom + " " + prestaDataPromise.prestaData.Prenom;
                   updateSalarySimData(prestaDataConverted, 0, false);
                }
              }
              else
              {
                var messageError = "PRESTA DATA IMPORT ERROR FOR EMPLOYER : " + formPrestaEmployer + "AND EMPLOYEE " + formPrestaEmployee;
                setPrestaImportMessage(messageError);
              }
            }
          }
        }
      }
    }
  }

  const ServiceCheckPrestaAccessEmployer = async (d: any) => {
    var accessOk = false;
    setEmployerName("");
    if(formPrestaEmployer)
    {
      var prestaCheckEmplPromise = await CheckPrestaAccessEmployer(getServiceUrl(), formPrestaEmployer);
      if(prestaCheckEmplPromise != null)
      {
        if (typeof prestaCheckEmplPromise == "string")
        {
          accessOk = false;
          popToast(toastType.Error, getKeyFromKeyId(prestaCheckEmplPromise));
        }
        else
        {
          accessOk = prestaCheckEmplPromise.accessOk;
          setEmployerName(prestaCheckEmplPromise.denomination);
        }
      }
      else
      {
        setEmployerName("");
        accessOk = false;
      }
    }
    else
    {
      setEmployerValid(0);
      return false;  
    }

    setEmployerValid(accessOk?1:2);
    return accessOk;
  }

  const ServiceCheckPrestaEmployee = async (e: any) => {
    var accessOk = false;
    setEmployeeName("");
    if(formPrestaEmployer != null && isNaN(formPrestaEmployer) == false)
    {
      if(formPrestaEmployee != null && isNaN(formPrestaEmployee) == false)
      {
        var prestaCheckEmployeePromise = await CheckPrestaEmployee(getServiceUrl(), formPrestaEmployer, formPrestaEmployee);
        if(prestaCheckEmployeePromise != null)
        {
          if(typeof prestaCheckEmployeePromise == 'string')
          {
            accessOk = false;
            popToast(toastType.Error, getKeyFromKeyId(prestaCheckEmployeePromise));
          }
          else
          {
            accessOk = prestaCheckEmployeePromise.accessOk;
            if(accessOk)
            {
              setEmployeeName(prestaCheckEmployeePromise.employeeContract.Nom + " " + prestaCheckEmployeePromise.employeeContract.Prenom);
            }
          }
        }
        else
        {
          accessOk = false;
        }
  
        setEmployeeValid(accessOk?1:2);
      }
      else
      {
        setEmployeeValid(2);
      }
    }
    else
    {
      setEmployerValid(2);
    }

      return accessOk;
  }

  const handleClickOpen = async () => {
    setPrestaPopupDisplay(true);

    // call presta to init login popup before checking employer
    var prestaInitPromise = await InitPresta(getServiceUrl());
    if(prestaInitPromise != null)
    {
      if (typeof prestaInitPromise == "string")
      {
        popToast(toastType.Error, getKeyFromKeyId(prestaInitPromise));
      }
    }
  };

  const handleClose = () => {
    setPrestaPopupDisplay(false);
  };

  const GetInputErrorStateCssClass = (state : number) => {
    if (state == 1)
    {
      return "text-field-img valided w-input";
    }
    else if(state == 2)
    {
      return "text-field-img error w-input";
    }
    else
    {
      return "w-input"
    }
  }

  return (
    <>
    <div className="alignEnd">
      <button type="button" id="button-gost" onClick={handleClickOpen} className="button-gost w-inline-block exportButton" aria-label={getKeyFromKeyId('CHARGER_DONNEES_PRESTA_TITLE')}>
        <p className="button-text-gost">{getKeyFromKeyId('CHARGER_DONNEES_PRESTA_TITLE')}</p>
      </button>
      </div>
    {prestaPopupDisplay && 
    <>
      <div className="pop-up">
        <div className="box-pop-up">
          <button type="button" aria-label="fermer la fenêtre" onClick={handleClose} className="ic-close w-button"></button>
          <h3 className="head-pop-up">{getKeyFromKeyId('CHARGER_DONNEES_PRESTA_TITLE')}</h3>
          
          <div className="form-block w-form">
            <form id="presta-form" name="presta-form" className="form-main" onSubmit={handleSubmit((d) => TryLoadFromPresta())}>
              <div className="main-pop-up">
                <div className="group-field">
                  <div className="group-label">
                    <label aria-hidden="true" htmlFor="employer-number" className="field-label-icon">{getKeyFromKeyId("NO_EMPLOYEUR")}</label>
                  </div>
                  <div className="text-field">
                    <input type="number" {...register('employerNum', { onChange: (e) => UpdateEmployer(e), onBlur: (e) => ServiceCheckPrestaAccessEmployer(e),})} className={GetInputErrorStateCssClass(employerValid)} autoFocus={true} maxLength={256} placeholder="0" id="employer-number" />
                  </div>
                  <label aria-hidden="true" htmlFor="employer-number" className="text-field-info">{employerName}</label>
                </div>
                <div className="group-field">
                  <div className="group-label">
                    <label aria-hidden="true" htmlFor="worker-number" className="field-label-icon">{getKeyFromKeyId("NO_TRAVAILLEUR")}</label>
                  </div>
                  <div className="text-field">
                    <input type="number" {...register('employeeNum', { onChange: (e) => UpdateEmployee(e), onBlur: (e) => ServiceCheckPrestaEmployee(e),})} className={GetInputErrorStateCssClass(employeeValid)} autoFocus={true} maxLength={256} placeholder="0" id="worker-number" />
                  </div>
                  <label aria-hidden="true" htmlFor="employer-number" className="text-field-info">{employeeName}</label>
                </div>
              </div>
              <button type="submit" className="button w-button loadButton">
              {prestaLoadingInProgress == true && <Lottie animationData={spinner} autoPlay={true} loop={true} className="lottie-animation" />}
              {prestaLoadingInProgress == false && getKeyFromKeyId("PRESTA_LOAD")}
              </button>
            </form>
          </div>
          <p className="pop-up-data">{prestaImportMessage}</p>
        </div>
      </div>
    </>
    }
    </>
  );

}

export default PrestaComponent;